<template>
  <!-- Sidebar - no fluxo normal, empurra o conteúdo quando visível -->
  <aside
    :class="[
      sidebarOpen ? 'w-64' : 'w-0 lg:w-20',
      'overflow-hidden transition-all duration-300 bg-white dark:bg-gray-800 border-r dark:border-gray-700 flex flex-col h-full',
    ]"
  >
    <!-- Topo do Sidebar - Logo -->
    <div class="flex items-center justify-center p-6 h-16 mt-5">
      <!-- Logo quando sidebar está aberto -->
      <transition name="fade">
        <div v-if="sidebarOpen" class="flex items-center overflow-hidden">
          <img
            src="/logo_avalioo.png"
            alt="Logo"
            class="w-48 flex-shrink-0"
          />
        </div>
      </transition>

      <!-- Favicon quando sidebar está fechado - visível apenas em desktop -->
      <transition name="fade">
        <div
          v-if="!sidebarOpen"
          class="hidden lg:flex items-center justify-center"
        >
          <img src="/apple-icon.png" alt="Logo" class="h-10 w-10" />
        </div>
      </transition>

      <!-- Botão toggle sidebar - visível apenas em mobile quando sidebar está aberto -->
      <button
        v-if="sidebarOpen"
        @click="$emit('toggle-sidebar')"
        class="lg:hidden absolute right-4 p-1 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
        aria-label="Toggle Menu"
      >
        <svg
          class="w-6 h-6 text-gray-600 dark:text-gray-300"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>

    <div class="px-4 py-3 border-b dark:border-gray-700">
      <div class="flex items-center relative">
        <!-- Nome do usuário (centralizado) -->
        <div class="flex-1 text-center px-6" :class="{ hidden: !sidebarOpen }">
          <span
            class="text-sm font-medium text-gray-700 dark:text-gray-200 truncate"
            >{{ userName }}</span
          >
        </div>

        <!-- Botão de logout (posicionado absolutamente à direita) -->
        <!-- Botão de logout (posicionado com base no estado do sidebar) -->
        <button
          @click="logout"
          :class="[
            'text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400 transition-colors',
            sidebarOpen ? 'absolute right-0' : 'mx-auto', // Centralizado quando fechado, à direita quando aberto
          ]"
          title="Sair"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Botões de utilidade -->
<div class="px-4 py-3 border-b dark:border-gray-700">
  <div class="grid grid-cols-2 gap-2">
    <!-- Alternar modo claro/escuro -->
    <button
      @click="$emit('toggle-dark-mode')"
      class="flex items-center justify-center p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
      :title="isDark ? 'Modo claro' : 'Modo escuro'"
    >
      <svg
        v-if="isDark"
        class="w-5 h-5 text-gray-600 dark:text-gray-300"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
        />
      </svg>
      <svg
        v-else
        class="w-5 h-5 text-gray-600 dark:text-gray-300"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
        />
      </svg>
    </button>

    <!-- Botão de feedback - COMENTADO
    <button
      @click="openFeedbackForm"
      class="flex items-center justify-center p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
      title="Enviar feedback"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-5 h-5 text-gray-600 dark:text-gray-300"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
        />
      </svg>
    </button>
    -->

    <!-- Botão de ajuda/wiki - COMENTADO
    <button
      @click="openHelpCenter"
      class="flex items-center justify-center p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
      title="Central de ajuda"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-5 h-5 text-gray-600 dark:text-gray-300"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </button>
    -->

    <!-- Botão de atendimento -->
    <a
      :href="whatsappSupportLink('Olá! Preciso de ajuda com o Avalioo.')"
      target="_blank"
      rel="noopener noreferrer"
      :class="[
        'flex items-center justify-center p-2 rounded-md transition-colors',
        sidebarOpen
          ? 'bg-green-100 text-green-700 hover:bg-green-200 dark:bg-green-900 dark:text-green-300 dark:hover:bg-green-800'
          : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700',
      ]"
      title="Atendimento via WhatsApp"
    >
      <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path
          d="M20.52 3.48A11.74 11.74 0 0012.05 1C6.17 1 .99 6.17.99 12.05a11.76 11.76 0 001.67 6.08L1 23l5.09-1.66a11.76 11.76 0 005.97 1.63h.05c5.88 0 11.06-5.18 11.06-11.06 0-3-.96-5.8-2.75-7.89zm-8.47 17.3h-.04a10.13 10.13 0 01-5.21-1.43l-.37-.22-3.03.98 1-2.95-.24-.38a10.12 10.12 0 01-1.57-5.45c0-5.6 4.56-10.16 10.16-10.16a10.1 10.1 0 017.16 2.98 9.99 9.99 0 012.98 7.14c0 5.6-4.56 10.16-10.14 10.16zm5.52-7.56c-.3-.15-1.78-.88-2.05-.98-.27-.1-.46-.15-.65.15s-.75.98-.92 1.18c-.17.2-.34.22-.63.07a8.24 8.24 0 01-2.41-1.5 9.03 9.03 0 01-1.66-2.06c-.17-.3 0-.46.13-.61.13-.14.3-.34.45-.5.15-.17.2-.3.3-.5.1-.2.05-.38-.02-.53-.07-.15-.65-1.56-.89-2.14-.23-.56-.47-.48-.65-.48h-.56c-.18 0-.46.07-.7.34s-.92.9-.92 2.2c0 1.3.94 2.56 1.07 2.74.13.17 1.82 2.78 4.41 3.89.62.27 1.1.43 1.47.55.62.2 1.2.17 1.65.1.5-.08 1.54-.63 1.76-1.25.23-.62.23-1.15.16-1.25-.07-.1-.26-.16-.56-.3z"
        />
      </svg>
    </a>
  </div>
</div>









    <!-- Navigation -->
    <nav class="mt-2 px-3 flex-1 overflow-y-auto">
      <div class="space-y-1">
        <!-- Renderiza cada menu group dinamicamente -->
        <div
          v-for="(menuGroup, groupIndex) in visibleMenuGroups"
          :key="groupIndex"
          :class="{
            'mb-5': menuGroup.items.length > 0,
            'mt-5': groupIndex > 0,
          }"
        >
          <!-- Título do grupo -->
          <p
            class="px-3 mt-4 text-xs font-semibold text-gray-400 uppercase transition-opacity duration-300"
            :class="{ 'opacity-0': !sidebarOpen }"
          >
            <span :class="{ hidden: !sidebarOpen }">{{ menuGroup.title }}</span>
          </p>

          <!-- Items do menu do grupo -->
          <router-link
            v-for="(item, itemIndex) in menuGroup.visibleItems"
            :key="itemIndex"
            :to="item.to"
            class="flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors"
            :class="[
              isActive(item.activePath)
                ? 'bg-blue-50 text-blue-600 dark:bg-blue-900 dark:text-blue-200'
                : 'text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700',
              { 'mt-1': itemIndex > 0 },
            ]"
          >
            <!-- Ícone do item -->
            <span
              v-html="item.icon"
              class="h-5 w-5 flex-shrink-0"
              :class="{ 'mr-2': sidebarOpen }"
            ></span>

            <!-- Texto do item -->
            <span :class="{ hidden: !sidebarOpen }">{{ item.text }}</span>
          </router-link>
        </div>
      </div>
    </nav>

    <!-- Botão para recolher/expandir o sidebar - apenas em desktop -->
    <div class="hidden lg:block border-t dark:border-gray-700 py-3 px-4">
      <button
        @click="$emit('toggle-sidebar')"
        class="flex items-center justify-center w-full p-2 text-sm font-medium text-gray-600 dark:text-gray-300 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          :class="{ 'rotate-180': !sidebarOpen }"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 19l-7-7 7-7m8 14l-7-7 7-7"
          />
        </svg>
        <span v-if="sidebarOpen" class="ml-2">Recolher menu</span>
      </button>
    </div>
  </aside>
</template>

<script>
import { computed, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { useWhatsappSupport } from "@/modules/shared/composables/useWhatsappSupport";

export default {
  name: "SidebarComponent",
  props: {
    sidebarOpen: {
      type: Boolean,
      required: true,
    },
    isDark: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["toggle-sidebar", "toggle-dark-mode"],
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const authStore = useAuthStore();
    const { whatsappSupportLink } = useWhatsappSupport();
    const userName = ref("");

    const isAdmin = computed(() => authStore.isAdmin);
    const isAgency = computed(() => authStore.isAgency);

    const userCompany = computed(() => {
      return authStore.user?.companyId || null;
    });

    const dashboardLink = computed(() => {
      if (isAdmin.value) {
        return "/admin/companies";
      } else if (userCompany.value) {
        return `/clients/statistics/${userCompany.value}`;
      } else {
        return "/agency/managed-companies";
      }
    });

    // Inicialização do nome do usuário
    onMounted(() => {
      if (authStore.user) {
        userName.value =
          authStore.user.username || authStore.user.email || "Usuário";
      } else {
        userName.value = "Usuário";
      }
    });

    // Iniciais do usuário para o avatar
    const userInitials = computed(() => {
      const name = userName.value || "";
      return name
        .split(" ")
        .map((n) => n[0])
        .slice(0, 2)
        .join("")
        .toUpperCase();
    });

    // Função de logout
    const logout = () => {
      router.push("/logout");
    };

    // Funções para os botões de utilidade
    const openFeedbackForm = () => {
      // Implementar abertura do formulário de feedback
      console.log("Abrir formulário de feedback");
      // Aqui você pode abrir um modal ou redirecionar para página de feedback
    };

    const openHelpCenter = () => {
      // Implementar navegação para o centro de ajuda/wiki
      console.log("Abrir centro de ajuda");
      //whatsappSupportLink('Olá! Preciso de ajuda com o Avalioo.');
      // Aqui você pode abrir um modal, redirecionar para wiki ou abrir em nova aba
    };

    // Define os ícones SVG como strings
    const icons = {
      companies: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>`,
      dashboard: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>`,
      reports: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>`,
      settings: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>`,
      financeiro: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z" />
                </svg>`,
      branches: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>`,
      preferences: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                    </svg>`,
      usuario: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
                </svg>`,
      agencia: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z" />
                </svg>`,
      licencas: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                 <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                 </svg>`,
      clientes: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z" />
                </svg>`,
    };

    // Configuração dos grupos de menu com visibilidade em nível de item
    const menuGroups = computed(() => [
      // Grupo Principal - Todos visualizam
      {
        title: "Principal",
        visible: true,
        items: [
          {
            text: "Meu Painel",
            to: dashboardLink.value,
            activePath: "/dashboard|/statistics",
            icon: icons.dashboard,
            visible: true, // Sempre visível
          },
          {
            text: "Relatórios",
            to: "/reports",
            activePath: "/reports",
            icon: icons.reports,
            visible: false, // Sempre visível
          },
          {
            text: "Configurações",
            to: "/settings",
            activePath: "/settings",
            icon: icons.settings,
            visible: false, // Sempre visível
          },
        ],
      },
      // Grupo Admin
      {
        title: "Admins",
        visible: isAdmin.value,
        items: [
          {
            text: "Empresas",
            to: "/admin/companies",
            activePath: "xyz",
            icon: icons.clientes,
            visible: true, // Sempre visível quando o grupo Admin é visível
          },
          {
            text: "Planos",
            to: "/admin/plans",
            activePath: "xyz",
            icon: icons.clientes,
            visible: true, // Sempre visível quando o grupo Admin é visível
          },
          {
            text: "Pacotes de Agências",
            to: "/admin/package-templates",
            activePath: "xyz",
            icon: icons.clientes,
            visible: true, // Sempre visível quando o grupo Admin é visível
          },
          {
            text: "Agências",
            to: "/admin/agencies",
            activePath: "xyz",
            icon: icons.companies,
            visible: true, // Sempre visível quando o grupo Admin é visível
          },
          {
            text: "Agências - Compras",
            to: "/admin/agency-purchases",
            activePath: "xyz",
            icon: icons.companies,
            visible: true, // Sempre visível quando o grupo Admin é visível
          },
          {
            text: "Licenças",
            to: "/admin/licenses2",
            activePath: "/admin/licenses2",
            icon: icons.licencas, // ALTERADO - feito por Claude Code - usando o ícone específico para licenças
            visible: true, // Sempre visível quando o grupo Admin é visível
          },
          {
            text: "Usuários",
            to: "/admin/companies",
            activePath: "xyz",
            icon: icons.usuario,
            visible: true, // Sempre visível quando o grupo Admin é visível
          },

          {
            text: "Financeiro",
            to: "/admin/companies",
            activePath: "xyz",
            icon: icons.financeiro,
            visible: true, // Sempre visível quando o grupo Admin é visível
          },
        ],
      },

      // Grupo Empresa
      {
        title: "Meu Menu", //ou melhor Cliente? ou Minhas Opções:
        visible: userCompany.value,
        items: [
          {
            text: "Meus Links",
            to: `/clients/meuslinks`,
            activePath: "/meuslinks",
            icon: icons.branches,
            visible: true, // Sempre visível quando o grupo Empresa é visível
          },
          {
            text: "Preferências",
            to: `/admin/companies/${userCompany.value}/preferences`,
            activePath: "/preferences",
            icon: icons.preferences,
            visible: false, // Sempre visível quando o grupo Empresa é visível
          },
        ],
      },
      // Grupo Agência
      {
        title: "Agência",
        visible: isAgency.value,
        items: [
          {
            text: "Empresas Gerenciadas",
            to: `/agency/managed-companies`,
            activePath: "/managed-companies",
            icon: icons.branches,
            visible: true, // Sempre visível quando o grupo Empresa é visível
          },
        ],
      },
    ]);

    // Filtra os grupos visíveis e calcula os itens visíveis para cada grupo
    const visibleMenuGroups = computed(() => {
      return menuGroups.value
        .filter((group) => group.visible)
        .map((group) => ({
          ...group,
          visibleItems: group.items.filter((item) => item.visible),
        }))
        .filter((group) => group.visibleItems.length > 0); // Remove grupos que não têm itens visíveis
    });

    // Verifica se a rota atual corresponde ao padrão do item do menu
    const isActive = (path) => {
      if (path.includes("|")) {
        // Suporta múltiplos padrões separados por |
        return path.split("|").some((p) => route.path.includes(p));
      }
      return route.path.includes(path);
    };

    return {
      visibleMenuGroups,
      isActive,
      userName,
      userInitials,
      logout,
      openFeedbackForm,
      openHelpCenter,
      whatsappSupportLink,
    };
  },
};
</script>

<style scoped>
/* Transição para o aparecimento/desaparecimento dos logos */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
